import { Icon } from './ui/icon'

export default function Loader() {
	return (
		<div className="absolute inset-0 z-20 flex items-center justify-center bg-white bg-opacity-50">
			<Icon name="lucide-loader-circle" className="animate-spin" size="md" />
		</div>
	)
}
